import React from "react";
import PropTypes from "prop-types";
import AvailabilityFilterHelpers from "helpers/availability-filter-helpers";
import AvailabilityPreferencesModalHelpers from "helpers/availability-preferences-modal-helpers";
import MembershipHelpers from "helpers/membership-helpers";
import RadioButtonSet from "components/source/shared/radio-button-set";

const { allAvailableFilterValue } = AvailabilityFilterHelpers;
const { allStylesAvailabilityFilterValue } = AvailabilityFilterHelpers;

class SubscriptionAvailabilityToggle extends React.Component {
  static propTypes = {
    membershipRentalBeginDate: PropTypes.string,
    membershipState: PropTypes.object,
    onChange: PropTypes.func,
    userData: PropTypes.shape({
      isUnlimitedLens: PropTypes.bool,
      isRTRUpdateLens: PropTypes.bool,
    }),
    workingFilters: PropTypes.object,
  };

  getValue() {
    return AvailabilityFilterHelpers.membershipMinAvailability(this.props.userData, this.props.workingFilters)
      ? allAvailableFilterValue
      : allStylesAvailabilityFilterValue;
  }

  onChange = e => {
    const { value } = e.target;
    this.props.onChange(value);
  };

  rentalBeginDate() {
    const isSubscriptionMember = MembershipHelpers.isSubscriptionMember(this.props.userData);
    if (isSubscriptionMember) {
      return AvailabilityFilterHelpers.getRentalBeginDate(this.props.membershipState);
    }
    return this.props.membershipRentalBeginDate;
  }

  getRentalBeginText() {
    const rentalBeginDateCopy = AvailabilityPreferencesModalHelpers.formatDate(this.rentalBeginDate(), "on");
    return `Delivery ${rentalBeginDateCopy}`;
  }

  renderAvailabilityToggle() {
    const rentalBeginText = this.getRentalBeginText();
    const allStylesLabel = "All Items in Your Membership";
    const baseClass = "availability-preference-on-rack-modal-contents";
    const descriptionClassName = `${baseClass}__label-description`;
    const defaultValue = this.getValue();

    const radioButtons = [
      {
        label: rentalBeginText,
        value: allAvailableFilterValue,
        description: <div className={descriptionClassName}>Items available now</div>,
      },
      {
        label: allStylesLabel,
        value: allStylesAvailabilityFilterValue,
        description: <div className={descriptionClassName}>Even currently unavailable items</div>,
      },
    ];

    return (
      <div className={`${baseClass}__radio ${baseClass}__radio--dfc-ux`}>
        <RadioButtonSet
          id={`${baseClass}__radio-toggle`}
          name="on-rack-toggle"
          onChange={this.onChange}
          radioButtons={radioButtons}
          defaultValue={defaultValue}
        />
      </div>
    );
  }

  render() {
    return <div className="subscription-availability-toggle">{this.renderAvailabilityToggle()}</div>;
  }
}

export default SubscriptionAvailabilityToggle;
